import { render, staticRenderFns } from "./majorInfo.vue?vue&type=template&id=0654772b&scoped=true"
import script from "./majorInfo.vue?vue&type=script&lang=js"
export * from "./majorInfo.vue?vue&type=script&lang=js"
import style0 from "./majorInfo.vue?vue&type=style&index=0&id=0654772b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0654772b",
  null
  
)

export default component.exports